




















































































import { ProductDisplayMode } from '@/model/product-display-mode';
import { ProductListState } from '@/model/product-list-state';
import { VueLoaderService } from '@/util/loader';
import { Util } from '@/util/util';
import Vue from 'vue';
import { ActionCollection } from '@/service/action-collection';
import { ProductListUtil } from '@/util/ProductListUtil';

interface VM {
  displayState: string;
  ProductListState: ProductListState;
  activeTotalColSpan: number;
}

export default Vue.extend({
  name: 'ProductList',
  components: {
    'product-item': VueLoaderService.lazyLoadComponent(import('../product-item/ProductItem.vue'))
  },
  props: {
    name: {
      type: String,
      default: 'products'
    },
    productKeys: {
      type: Array as () => Array<string>,
      required: true
    },
    columns: {
      type: Array as () => string[],
      required: true
    },
    displayMode: {
      type: String,
      required: true,
      validator: ProductDisplayMode.isValidDisplayMode
    },
    actionCollection: {
      type: Object as () => ActionCollection,
      default: () => new ActionCollection()
    },
    businessUnit: {
      type: String,
      required: true
    },
    productCategory: {
      type: String,
      required: true
    },
    v2Styling: {
      type: Boolean,
      default: false
    },
  },
  data(): VM {
    return {
      displayState: ProductListState.NOT_LOGGED_IN,
      ProductListState: ProductListState,
      activeTotalColSpan: 0
    };
  },
  mounted() {
    this.displayState = Util.isLoggedIn() ? ProductListState.LOGGED_IN : ProductListState.NOT_LOGGED_IN;

    const self = this;
    setTimeout(function() {
      self.setActiveTotalColSpan();
    }, 1000);

    window.addEventListener('resize', this.setActiveTotalColSpan);
  },
  beforeDestroy(): void {
    window.removeEventListener('resize', this.setActiveTotalColSpan);
  },
  computed: {
    showGrossPrice(): boolean {
      return this.businessUnit.toLowerCase() === 'agricultural' && this.productCategory.toLowerCase() === 'banden_gebruikt';
    }
  },
  methods: {
    getTableTheadChildren(): Element[] {
      const tableElement = this.$el.getElementsByTagName('table')[0];
      if (tableElement == null || tableElement.tHead == null) return [];
      return Array.from(tableElement.tHead.rows[0].children);
    },
    updateView() {
      this.$forceUpdate();
    },
    hasAfterSlotContent(index: number): boolean {
      if (this.$el == null) return false;
      const element = this.$el.querySelector(`td.after-slot-td[data-index="${index}"]`);
      return element != null && element.children.length > 0;
    },
    hasBeforeSlotContent(index: number): boolean {
      if (this.$el == null) return false;
      const element = this.$el.querySelector(`td.before-slot-td[data-index="${index}"]`);
      return element != null && element.children.length > 0;
    },
    getResponsiveClass(businessUnit: string, productCategory: string, columnName: string): String {
      return ProductListUtil.getResponsiveClass(businessUnit, productCategory, columnName);
    },

    setActiveTotalColSpan() {
      const children = this.getTableTheadChildren();

      const getActiveColSpan = () => {
        const d1024 = 'd-1024px-none';
        const d1220 = 'd-1220px-none';
        const d1440 = 'd-1440px-none';

        const condition = (child: Element) => {
          const doesNotContainClassesOf = (...classNames: string[]) =>
            classNames.every(className => child.classList.contains(className) == false);

          const windowWidth = window.innerWidth;
          const isWindowWidthBetween = (min: number, max: number) => windowWidth > min && windowWidth < max;

          return (
            windowWidth > 1440 ||
            (isWindowWidthBetween(1221, 1441) && doesNotContainClassesOf(d1440)) ||
            (isWindowWidthBetween(1024, 1221) && doesNotContainClassesOf(d1220, d1440)) ||
            (windowWidth < 1025 && doesNotContainClassesOf(d1024, d1220, d1440))
          );
        };

        return children.filter(condition).length;
      };

      this.activeTotalColSpan = getActiveColSpan();
    }
  }
});
